import { ErpOrderHistoryItem } from '@ca/common/types'
import OrderHistoryTile from './Tile'

interface Props {
  data: ErpOrderHistoryItem
  onPress: () => void
}

export default function OrderHistoryItem({ data, onPress }: Props) {
  return <OrderHistoryTile data={data} onPress={onPress} />
}
